<template>
  <div class="bg position-relative">
    <div class="bc">
      <div class="top_space"/>
      <div class="input_area">
        <div class="row no-gutters">
          <div class="text_label">姓名<span class="must">*</span></div>
          <div class="col">
            <input class="input_style" v-model="joinData.name" placeholder="請輸入收件人姓名" @blur="validateNull('name')"
                   alt="姓名"/>
            <div v-if="isNotEmpty(errors.name)" class="error-message">{{ errors.name }}</div>
          </div>
        </div>
        <div style="height: 24px;"/>
        <div class="row no-gutters">
          <div class="text_label">連絡電話<span class="must">*</span></div>
          <div class="col">
            <input class="input_style" v-model="joinData.phone_number" placeholder="請輸入收件人連絡電話" @input="limitInput"
                   alt="連絡電話"/>
            <div v-if="isNotEmpty(errors.phone_number)" class="error-message">{{ errors.phone_number }}</div>
          </div>
        </div>
        <div style="height: 24px;"/>
        <div class="row no-gutters">
          <div class="text_label">電子信箱<span class="must">*</span></div>
          <div class="col">
            <input class="input_style" v-model="joinData.email" placeholder="請輸入收件人電子信箱" alt="電子信箱"/>
            <div v-if="isNotEmpty(errors.email)" class="error-message">{{ errors.email }}</div>
          </div>
        </div>
        <div style="height: 24px;"/>
        <div class="row no-gutters">
          <div class="text_label">LINE ID<span class="must">*</span></div>
          <div class="col">
            <input class="input_style" v-model="joinData.line_id" placeholder="請輸入LINE ID" alt="LINE ID"/>
            <div v-if="isNotEmpty(errors.line_id)" class="error-message">{{ errors.line_id }}</div>
          </div>
        </div>
        <div style="height: 24px;"/>
        <div class="row no-gutters">
          <div class="text_label">預設加盟地區<span class="must">*</span></div>
          <div class="col">
            <input class="input_style" v-model="joinData.area" placeholder="請輸入縣市地區，例：台北市-中山區" alt="預設加盟地區"/>
            <div v-if="isNotEmpty(errors.area)" class="error-message">{{ errors.area }}</div>
          </div>
        </div>
        <div style="height: 24px;"/>
        <div class="row no-gutters">
          <div class="text_label">金額預算<span class="must">*</span></div>
          <div class="col">
            <input class="input_style" v-model="joinData.budget" placeholder="例：50萬台幣" alt="金額預算"/>
            <div v-if="isNotEmpty(errors.budget)" class="error-message">{{ errors.budget }}</div>
          </div>
        </div>
        <div style="height: 24px;"/>
        <div class="row no-gutters">
          <div class="text_label">備註</div>
          <div class="col">
            <textarea class="input_style " rows="3" v-model="joinData.note" placeholder="請輸入備註" alt="備註"/>
          </div>
        </div>
        <div style="height: 24px;"/>
        <div class="btn_area">
          <button type="button" class="btn btn_style btn-primary" @click="clickSubmit">
            <span class="btn_text">送出表單</span>
          </button>
        </div>
      </div>
      <div class="down_space"/>

    </div>
  </div>
</template>

<script>
import {checkError, isEmpty} from "../../util/helpers";
import {validateEmail, validatePhone} from "../../util/rules";
import ActionDialog from "../dialog/ActionDialog";
import {getStoreFranchises} from "../../api/api";

export default {
  components: {ActionDialog},
  name: "Join_2",
  data() {
    return {
      joinData: {
        name: "",
        phone_number: "",
        email: "",
        line_id: "",
        budget: "",
        area: "",
        note: ""
      },
      errors: {
        name: '',
        phone_number: '',
        line_id: "",
        budget: "",
        area: "",
        note: ""
      }
    };
  },
  methods: {
    limitInput() {
      this.joinData.phone_number = this.joinData.phone_number.replace(/\D/g, '').slice(0, 10);
    },
    isNotEmpty(val) {
      return isEmpty(val) === false;
    },
    validateNull(type) {
      switch (type) {
        case "name" :
          if (isEmpty(this.joinData.name)) {
            this.errors.name = '*您尚未填寫資料';
          } else {
            this.errors.name = '';
          }
          break;
        case "phone_number" :
          if (isEmpty(this.joinData.phone_number)) {
            this.errors.phone_number = '*您尚未填寫資料';
          } else if (validatePhone(this.joinData.phone_number)) {
            this.errors.phone_number = "*連絡電話格式錯誤格式錯誤";
          } else {
            this.errors.phone_number = '';
          }
          break;
        case "email" :
          if (isEmpty(this.joinData.email)) {
            this.errors.email = '*您尚未填寫資料';
          } else if (validateEmail(this.joinData.email)) {
            this.errors.email = "*電子郵件格式錯誤";
          } else {
            this.errors.email = '';
          }
          break;

        case "line_id" :
          if (isEmpty(this.joinData.line_id)) {
            this.errors.line_id = '*您尚未填寫資料';
          } else {
            this.errors.line_id = '';
          }
          break;

        case "area" :
          if (isEmpty(this.joinData.area)) {
            this.errors.area = '*您尚未填寫資料';
          } else {
            this.errors.area = '';
          }
          break;

        case "budget" :
          if (isEmpty(this.joinData.budget)) {
            this.errors.budget = '*您尚未填寫資料';
          } else {
            this.errors.budget = '';
          }
          break;
      }
    },
    areAllErrorsEmpty() {
      return Object.values(this.errors).every(value => isEmpty(value));
    },
    async clickSubmit() {
      this.validateNull('name');
      this.validateNull('phone_number');
      this.validateNull('email');
      this.validateNull('line_id');
      this.validateNull('area');
      this.validateNull('budget');

      let result = this.areAllErrorsEmpty();
      if (result === false) return;
      result = await this.$dialog.show(ActionDialog, {text: "請確認表單內容填寫無誤，即將送出表單。"});
      if (result === false) return;
      try {
        await this.$store.dispatch('showLoading');
        let response = await getStoreFranchises(this.joinData);
        if (await checkError(this.$dialog, response)) {
          await this.$store.dispatch('hideLoading');
          this.$emit('submit');
        }
      } catch (e) {
        console.log('error ', e);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.bg {
  background-image: url('/img/image/background/bg_s11.png');
  background-size: cover; /* 确保背景图像覆盖整个元素 */
  background-position: center; /* 将图像居中 */
  background-repeat: no-repeat; /* 防止图像重复 */
}

.bc {
  margin: 0 auto;
  height: auto;
  max-width: 1440px;
  text-align: center;
}


.input_area {
  width: 1120px;
  padding: 26px;
  margin: 0 auto;
  background-color: #FAFAFA;
}

@media (max-width: 1120px) {
  .input_area {
    width: 100%
  }
}

.top_space, .down_space {
  height: 42px;
}

@media (max-width: 1120px) {
  .top_space, .down_space {
    height: 0;
  }
}

.input_style {
  font-family: Noto Sans TC;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #333333;
  padding: 12px;
  border: 0.5px solid #DDE1E9;
  resize: none; /* 禁用用户调整大小 */
  overflow: auto; /* 确保超出内容时可以滚动 */
  width: 100%;
}

.input_style::placeholder {
  color: #888;
}


.text_label {
  max-width: 160px;
  width: 160px;
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}

@media (max-width: 425px) {
  .text_label {
    font-size: 16px;
    min-width: 112px;
    width: 30%;
  }
}

.must {
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
  color: #D56835;
}

@media (max-width: 425px) {
  .must {
    font-size: 16px;
  }
}

.error-message {
  color: #D60404;
  font-size: 14px;
  margin-top: 8px;
  margin-left: 8px;
  text-align: left;
}

@media (max-width: 425px) {
  .error-message {
    margin-top: 4px;
    margin-left: 4px;
    font-size: 14px;
  }
}

.btn_area {
  text-align: right;
}

.btn_style {
  width: 280px;
  height: 64px;
  padding: 0;
}

@media (max-width: 700px) {
  .btn_style {
    width: 200px;
    height: 48px;
  }
}

@media (max-width: 425px) {
  .btn_style {
    width: 120px;
    height: 32px;
  }
}

.btn_text {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 500;
  text-align: center;
  color: white;
}

@media (max-width: 425px) {
  .btn_text {
    line-height: 0;
    font-size: 16px;
  }
}
</style>
